// Add aria-popup to dropdown items
wpex.domReady(async function() {
    let selectors = [ '.menu-item.dropdown > a' ];

   SL9.a11y.setAriaAttr( selectors, 'true', 'aria-haspopup' );
});